import SelectOrganization from "@/pages/dashboard/organization/index"
import CreateOrganization from "@/pages/dashboard/organization/create"
import JoinOrganization from "@/pages/dashboard/organization/join"
import { ROUTES } from "./path"
import React from "react"
import { AppRouteConfig } from "@/types/navigation"

export const organizationRoutes: AppRouteConfig[] = [
  {
    path: ROUTES.DASHBOARD.ORGANIZATION.INDEX,
    element: React.createElement(SelectOrganization),
    restricted: true,
    showNav: false,
    showSideBar: false,
  },
  {
    path: ROUTES.DASHBOARD.ORGANIZATION.CREATE,
    element: React.createElement(CreateOrganization),
    restricted: true,
    showNav: false,
    showSideBar: false,
  },
  {
    path: ROUTES.DASHBOARD.ORGANIZATION.JOIN,
    element: React.createElement(JoinOrganization),
    restricted: true,
    showNav: false,
    showSideBar: false,
  },
]
